<ng-container *transloco="let t">
<tui-accordion class="tui-space_top-5 tui-space_bottom-5">
    <button tuiAccordion>{{ t('adultLearn.accordion.description') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('adultLearn.accordion.descriptionContent.paragraph1') }}</p>
        <img src="../../../../../assets/img/scheme3.jpg"  class="img-text-100" alt="">
        <p class="text tui-space_bottom-3">{{ t('adultLearn.accordion.descriptionContent.paragraph2') }}</p>
        <p class="text tui-space_bottom-3">{{ t('adultLearn.accordion.descriptionContent.paragraph3') }}</p>
        <p class="text tui-space_bottom-3">{{ t('adultLearn.accordion.descriptionContent.paragraph4') }}</p>
        <p class="text tui-space_bottom-3">{{ t('adultLearn.accordion.descriptionContent.paragraph5') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('adultLearn.accordion.verbalSigns') }}</button>
    <tui-expand>
        <h4 class="tui-space_top-3 tui-space_bottom-3">
            {{ t('adultLearn.accordion.verbalSignsContent.title') }}
        </h4>
        <ul class="tui-list tui-list_large">
            @for (item of t('adultLearn.accordion.verbalSignsContent.phrases'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
        <p class="text tui-space_bottom-3">{{ t('adultLearn.accordion.verbalSignsContent.explanation') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('adultLearn.accordion.physicalSigns') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('adultLearn.accordion.physicalSignsContent') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('adultLearn.accordion.behavior') }}</button>
    <tui-expand>
        <ul class="tui-list tui-list_large">
            @for (item of t('adultLearn.accordion.behaviorContent'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
    </tui-expand>
    <button tuiAccordion>{{ t('adultLearn.accordion.externalManifestations') }}</button>
    <tui-expand>
        <ul class="tui-list tui-list_large">
            @for (item of t('adultLearn.accordion.externalManifestationsContent'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
    </tui-expand>
    <button tuiAccordion>{{ t('adultLearn.accordion.functions') }}</button>
    <tui-expand>
        <ul class="tui-list tui-list_large">
            @for (item of t('adultLearn.accordion.functionsContent'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
    </tui-expand>
    <button tuiAccordion>{{ t('adultLearn.accordion.examples') }}</button>
    <tui-expand>
        <ul class="tui-list tui-list_large">
            @for (item of t('adultLearn.accordion.examplesContent.examples'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
        <p class="text tui-space_bottom-3">{{ t('adultLearn.accordion.examplesContent.conclusion') }}</p>
    </tui-expand>
</tui-accordion>
</ng-container>